/* ReStyle Lab - corregge il conteggio delle pagine degli slider (es. "Esplora per categoria": 1/3 -> 1/2).
   Dawn calcola le slide visibili senza tener conto che l'ultima slide non ha lo spazio finale (gap). */
customElements.whenDefined('slider-component').then(function () {
  var proto = customElements.get('slider-component').prototype;
  var original = proto.initPages;

  proto.initPages = function () {
    if (this.tagName === 'SLIDESHOW-COMPONENT') return original.call(this);

    this.sliderItemsToShow = Array.from(this.sliderItems).filter(function (el) {
      return el.clientWidth > 0;
    });
    if (this.sliderItemsToShow.length < 2) return;

    var first = this.sliderItemsToShow[0];
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - first.offsetLeft;
    var gap = Math.max(0, this.sliderItemOffset - first.offsetWidth);
    this.slidesPerPage = Math.max(
      1,
      Math.floor((this.slider.clientWidth - first.offsetLeft + gap + 1) / this.sliderItemOffset)
    );
    this.totalPages = Math.max(1, this.sliderItemsToShow.length - this.slidesPerPage + 1);
    this.update();
  };

  document.querySelectorAll('slider-component').forEach(function (el) {
    if (el.slider && el.nextButton) el.initPages();
  });
});
